import React from "react";
import { ClockIcon } from "@heroicons/react/20/solid";

export const ReportHoursTag = ({ event, className = "" }) => {
  // Try to get total_hours from different sources
  let totalHours = 0;
  
  if (event.module_details?.total_hours) {
    totalHours = parseFloat(event.module_details.total_hours) || 0;
  }

  // Only show if we have hours
  if (totalHours <= 0) {
    return null;
  }

  return (
    <div className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800 ${className}`}>
      <ClockIcon className="h-3 w-3 mr-1" />
      <span>{totalHours}h</span>
    </div>
  );
};
